







































































import Vue from "vue";
import moment from "moment";
import Web3 from "web3";
import { setIntervalAsync, clearIntervalAsync, SetIntervalAsyncTimer } from "set-interval-async/fixed";

export default Vue.extend({
  name: "TransactionMonitor",

  data: () => ({
    isStarted: false as boolean,
    fromChecked: false as boolean,
    from: "" as string,
    toChecked: false as boolean,
    to: "" as string,
    methodChecked: false as boolean,
    method: "" as string,
    btnColor: "primary" as string,
    btnText: "Start" as string,
    items: [] as Array<any>,
    errors: [] as string[],
    interval: undefined as SetIntervalAsyncTimer | undefined,
  }),
  methods: {
    async click(): Promise<void> {
      if (!this.fromChecked && !this.toChecked && !this.methodChecked) {
        this.errors.push("少なくとも1つは指定してください。");
        return;
      }

      if (this.isStarted) {
        if (this.interval != undefined) {
          await clearIntervalAsync(this.interval);
        }
        this.errors.splice(0);
        this.btnColor = "primary";
        this.btnText = "Start";
        this.isStarted = false;
        return;
      }

      const web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed1.defibit.io:443"));
      web3.extend({
        property: "txpool",
        methods: [
          {
            name: "content",
            call: "txpool_content",
          },
        ],
      });

      this.isStarted = true;
      this.btnColor = "secondary";
      this.btnText = "Stop";
      this.items.splice(0);

      // transaction の監視を開始
      const checkedTransactionHashs: string[] = [];
      this.interval = setIntervalAsync(async () => {
        const result = await (web3 as any).txpool.content();
        const pendingTransactions: any[] = Object.values(result.pending);
        for (const pendingTransaction of pendingTransactions) {
          const transactions: any[] = Object.values(pendingTransaction);
          for (const transaction of transactions) {
            if (transaction == null || checkedTransactionHashs.includes(transaction.hash)) {
              continue;
            }
            if (this.fromChecked && transaction.from.toLowerCase() != this.from.toLowerCase()) {
              checkedTransactionHashs.push(transaction.hash);
              if (checkedTransactionHashs.length > 20000) {
                const deleteCount = checkedTransactionHashs.length - 20000;
                checkedTransactionHashs.splice(0, deleteCount);
              }
              continue;
            }
            if (this.toChecked && transaction.to.toLowerCase() != this.to.toLowerCase()) {
              checkedTransactionHashs.push(transaction.hash);
              if (checkedTransactionHashs.length > 20000) {
                const deleteCount = checkedTransactionHashs.length - 20000;
                checkedTransactionHashs.splice(0, deleteCount);
              }
              continue;
            }
            const methodId = transaction.input.slice(0, 10);
            if (this.methodChecked && methodId.toLowerCase() != this.method.toLowerCase()) {
              checkedTransactionHashs.push(transaction.hash);
              if (checkedTransactionHashs.length > 20000) {
                const deleteCount = checkedTransactionHashs.length - 20000;
                checkedTransactionHashs.splice(0, deleteCount);
              }
              continue;
            }
            const index = this.items.findIndex((item) => item.transactionHash == transaction.hash);
            if (index === -1) {
              this.items.push({
                date: `${moment().format("YYYY/MM/DD HH:mm:ss")}`,
                from: Web3.utils.toChecksumAddress(transaction.from),
                to: Web3.utils.toChecksumAddress(transaction.to),
                method: methodId,
                transactionHashLink: `https://bscscan.com/tx/${transaction.hash}`,
              });
            }
            checkedTransactionHashs.push(transaction.hash);
            if (checkedTransactionHashs.length > 20000) {
              const deleteCount = checkedTransactionHashs.length - 20000;
              checkedTransactionHashs.splice(0, deleteCount);
            }
          }
        }
      }, 10);
    },
  },
});
